// src/helpers/factories/settings/guestCheckSettingsFactory.ts
var GUEST_CHECK_SORT_ITEMS_BY_OPTIONS = [
  "menuCourse" /* MENU_COURSE */,
  "registerCourse" /* REGISTER_COURSE */,
  "timeAddedToTicket" /* TIME_ADDED_TO_TICKET */,
  "timeSentToKitchen" /* TIME_SENT_TO_KITCHEN */
];
var GUEST_CHECK_SECOND_SORT_PRIORITY_OPTIONS = [
  "alphabetical" /* ALPHABETICAL */,
  "timeAddedToTicket" /* TIME_ADDED_TO_TICKET */
];
var guestCheckSortItemsByFactory = (t) => GUEST_CHECK_SORT_ITEMS_BY_OPTIONS.map((option, index) => ({
  label: t(`settingsModule.guestCheckSettings.sortItemsBy.options.${option}`),
  value: index + 1
}));
var guestCheckSecondSortPriorityFactory = (t) => GUEST_CHECK_SECOND_SORT_PRIORITY_OPTIONS.map((option, index) => ({
  label: t(
    `settingsModule.guestCheckSettings.secondSortItemsBy.options.${option}`
  ),
  value: index + 1
}));

export { GUEST_CHECK_SECOND_SORT_PRIORITY_OPTIONS, GUEST_CHECK_SORT_ITEMS_BY_OPTIONS, guestCheckSecondSortPriorityFactory, guestCheckSortItemsByFactory };
